/**
 * Copyright (c) Microsoft. All rights reserved.
 */
import * as React from 'react';
export const MultiLineSvgRenderer = (props) => {
    const { color, strokeWidth, strokeLinecap = 'round', linePoints, strokeDasharray } = props;
    return (React.createElement(React.Fragment, null, linePoints.map((points, index) => (React.createElement("polyline", { key: index, fill: color, stroke: color, strokeWidth: strokeWidth, strokeLinecap: strokeLinecap, strokeDasharray: strokeDasharray, points: points.map(({ x, y }) => `${x},${y}`).join(' ') })))));
};
